import { ref } from 'vue'
import { setError } from '@/utils/errorHandler' // Import the setError function
// Optionally, if you want to use the shared error handler:
// import { setError } from '@/utils/errorHandler'

export function useLecturer() {
  const lecturer = ref(null)
  const loading = ref(false)
  const error = ref(null)

  async function fetchLecturer(lecturerSlug) {
    console.log("fetchLecturer called with slug:", lecturerSlug)
    loading.value = true
    error.value = null

    try {
      const brandId = window.vueAppConfig?.info?.id || 'kVDeWQzE'
      const response = await fetch(
        `${window.vueAppConfig.endpoint}/api/v2/events/lecturers/fetch`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ slug: lecturerSlug, brand_id: brandId })
        }
      )
      console.log("Response received:", response)

      // Check for specific HTTP error status codes before parsing JSON
      if ([429, 403, 500, 404].includes(response.status)) {
        let message = ''
        let waitTime = null

        switch (response.status) {
          case 429:
            message = 'You have made too many requests. Please wait before trying again.'
            waitTime = 60 // Optionally set a wait time for retry
            break
          case 403:
            message = 'You do not have permission to access this resource.'
            break
          case 500:
            message = 'An unexpected server error occurred. Please try again later.'
            break
          case 404:
            message = 'Lecturer not found.'
            break
          default:
            message = 'An unexpected error occurred.'
        }

        // If you're using a shared error handler, you can call:
         setError(response.status, message, waitTime)
        error.value = message
        return // Exit early to avoid further processing
      }

      // Parse the response JSON if no HTTP errors occurred
      const data = await response.json()
      console.log("Data received:", data)
      if (data.status) {
        lecturer.value = data.data
      } else {
        // Even if HTTP is OK, the API might return status false with an error message.
        error.value = data.message || 'Failed to fetch lecturer.'
      }
    } catch (err) {
      error.value = err.message || 'Error fetching lecturer.'
      console.error("Error in fetchLecturer:", err)
    } finally {
      loading.value = false
    }
  }

  return {
    lecturer,
    loading,
    error,
    fetchLecturer
  }
}
